import React, { Component } from "react";
import { Grid, Row, Col, Modal, InputGroup } from "react-bootstrap";
import auth from "../../../services/authService";
import Select from "../../../components/Common/select";
import * as stuffingService from "../../../services/stuffingServices";
import Input from "../../../components/Common/input";
import Checkbox from "../../../components/Common/checkbox";
import Textarea from "../../../components/Common/textarea";
import LightBox from "../../../components/Common/lightbox";
import Loader from "react-loader-spinner";
import Datetime from "react-datetime";
import { qcStuffingImg } from "../../../services/config.json";
import imageCompression from "browser-image-compression";

var base64 = require("base-64");
class QCStuffing extends Component {
  state = {
    data: {
      container: "",
      group: "",
      stuffing_date: "",
      dateFrom: "",
      dateTo: "",
      notes: "",
      transaction_date: "",
      titik: [],
      detail: [],
    },
    eItems: [],
    openModalNotif: false,
    openModalUpdate: false,
    isOpen: false,
    image: "",
    uploading: false,
    selectedFile: null,
    allowFile: false,
    titik: [],
    selectedIndex: -1,
    selectedDimensi: -1,
    currentOpenModalUpload: false,
    selectedSurface: -1,
    status: [
      { label: "Pending", value: "1" },
      { label: "Approved", value: "2" },
      { label: "Declined", value: "-1" },
    ],
    stuffing_type: [
      { label: "FCL", value: "1" },
      { label: "LCL", value: "2" },
    ],
    isProcessed: false,
  };

  // handleSelectedFoto = event => {
  //   const { selectedIndex, selectedSurface } = this.state;
  //   console.log(selectedIndex);
  //   if (selectedIndex >= 0 && selectedSurface >= 0) {
  //     let data = { ...this.state.data };
  //     let surface = [...data.surface[selectedIndex].foto];
  //     let item = { ...surface[selectedSurface] };
  //     item.file = event.target.files[0];
  //     surface[selectedSurface] = item;
  //     data.surface[selectedIndex].foto = surface;
  //     if (this.mount) {
  //       this.setState({ data });
  //     }
  //   }
  // };
  handleSelectedFile = async (event) => {
    const { selectedIndex, selectedDimensi } = this.state;
    if (selectedIndex >= 0 && selectedDimensi >= 0) {
      let data = { ...this.state.data };
      let titik = [...data.titik[selectedIndex]];
      let item = { ...titik[selectedDimensi] };
      const options = {
        maxSizeMB: 1,
        maxWidthOrHeight: 1920,
        useWebWorker: true,
      };
      const compressedFile = await imageCompression(
        event.target.files[0],
        options
      );
      item.file = compressedFile;
      titik[selectedDimensi] = item;
      data.titik[selectedIndex] = titik;
      if (this.mount) {
        this.setState({ data });
      }
    }
    // this.setState({
    //   selectedFile: event.target.files[0],
    //   allowFile: this.checkExt(event.target.files[0].name)
    // });
  };
  handleChangeNumberTitik = (val, index, target) => {
    const { selectedIndex } = this.state;
    if (selectedIndex >= 0) {
      let data = { ...this.state.data };
      let titik = [...data.titik[selectedIndex]];
      let item = { ...titik[index] };
      item[target] = val.formattedValue;
      titik[index] = item;
      data.titik[selectedIndex] = titik;
      if (this.mount) {
        this.setState({ data });
      }
    }
  };

  handleChangeDetail = ({ currentTarget: input }, target) => {
    const { selectedIndex } = this.state;
    if (selectedIndex >= 0) {
      let data = { ...this.state.data };
      let detail = { ...data.detail[selectedIndex] };
      detail[target] = input.value;
      data.detail[selectedIndex] = detail;
      if (this.mount) {
        this.setState({ data }, () => {
          if (target === "id_stuffing_type") {
            this.getChecklist();
          }
        });
      }
    }
  };
  handleToggleCheckbox = (val, index, idx, target) => {
    // const { selectedIndex } = this.state;
    // if (selectedIndex >= 0) {
    let data = { ...this.state.data };
    let titik = [...data.titik[index]];
    let item = { ...titik[idx] };
    item[target] = !item[target];
    titik[idx] = item;
    data.titik[index] = titik;
    if (this.mount) {
      this.setState({ data });
    }
    // }
  };
  handleChangeTitik = ({ currentTarget: input }, index, idx, target) => {
    // const { selectedIndex } = this.state;
    // if (selectedIndex >= 0) {
    let data = { ...this.state.data };
    let titik = [...data.titik[index]];
    let item = { ...titik[idx] };
    item[target] = input.value;
    titik[idx] = item;
    data.titik[index] = titik;
    if (this.mount) {
      this.setState({ data });
    }
    // }
  };
  handleChangeNumber = (val, target) => {
    const data = { ...this.state.data };
    data[target] = val.formattedValue;
    if (this.mount) {
      this.setState({ data });
    }
  };
  checkExt(val) {
    let temp = val.substring(val.length - 4);
    temp = temp.replace(".", "");
    let acceptable = false;
    if (
      temp.toLowerCase() === "jpg" ||
      temp.toLowerCase() === "png" ||
      temp.toLowerCase() === "jpeg" ||
      temp.toLowerCase() === "pdf"
    ) {
      acceptable = true;
    }
    return acceptable;
  }
  getData = async () => {
    const { data } = this.state;
    let tempEItem = [];
    await stuffingService.getQCStuffingReport(data).then((data) => {
      const temp = { ...this.state.data };
      let temps = data.dimensi
        ? data.dimensi.map((stuffing) => {
            return {
              ...stuffing,
              nilai: stuffing.status==="1"?true:false,
              // status_image: "",
              file: null,
              // desc: "",
              // stuffing_name: "",
              // stuffing_name_english: "",
              is_show:true,
              is_extra: stuffing.id_stuffing_checklist !=='' ? false:true,
            };
          })
        : [];
      if (data.dimensi) {
        for (var i = 0; i < data.dimensi.length; i++) {
          const eItemIdx = this.checkLocalItem(data.dimensi[i].container, tempEItem);
          if (eItemIdx < 0) {
            tempEItem = [...tempEItem, { ...data.dimensi[i], jumlah: 1 }];
          } else {
            tempEItem[eItemIdx].jumlah += 1;
          }
        }
      }
      temp.titik = data.dimensi ? [temps] : [];
      temp.detail = [
        { ...data.qc },
      ];
      this.setState({
        data: temp,
        eItems: tempEItem
        // titik: data.dimensi ? temps : [],
      });
    });
  };
  checkLocalItem = (container, items) => {
    let idx = -1;
    for (var i = 0; i <= items.length; i++) {
      if (items[i] && items[i].container == container) {
        idx = i;
        break;
      }
    }
    return idx;
  };
  handleAddQc = () => {
    let { titik } = this.state;
    let tempdetail = {
      container: "",
      notes: "",
      status: "1",
      id_stuffing_type: 1,
    };
    let temp = [...this.state.data.titik, titik];
    let detail = [...this.state.data.detail, tempdetail];
    const data = { ...this.state.data };
    data.titik = temp;
    data.detail = detail;
    this.setState({ data });
  };
  handleAddTitik = (index) => {
    let tempdetail = {
      is_photo: 1,
      nilai: false,
      status_image: "",
      file: null,
      desc: "",
      stuffing_name: "",
      stuffing_name_english: "",
      is_extra: true,
    };
    let titik = [...this.state.data.titik[index], tempdetail];
    const data = { ...this.state.data };
    data.titik[index] = titik;
    this.setState({ data });
  };
  getChecklist = async () => {
    const { selectedIndex } = this.state;
    let data = { ...this.state.data };
    let detail = { ...data.detail[selectedIndex] };
    await stuffingService
      .getAllStuffing(detail.id_stuffing_type)
      .then((data) => {
        console.log(data);
        const temp = { ...this.state.data };
        let temps = data.stuffing
          ? data.stuffing.map((stuffing) => {
              return {
                ...stuffing,
                nilai: false,
                status_image: "",
                file: null,
                desc: "",
              };
            })
          : [];
        temp.titik[selectedIndex] = data.stuffing ? [...temps] : [];
        this.setState({
          data: temp,
        });
      });
  };
  handleChange = ({ currentTarget: input }) => {
    const data = { ...this.state.data };
    data[input.name] = input.value;
    if (this.mount) {
      this.setState({ data });
    }
  };
  handleChangeDate = (e, target) => {
    if (typeof e === "object") {
      let datetime = e.format("YYYY-MM-DD");
      const data = { ...this.state.data };
      data[target] = datetime;
      if (this.mount) {
        this.setState({ data });
      }
    } else {
      const data = { ...this.state.data };
      data[target] = "";
      if (this.mount) {
        this.setState({ data });
      }
    }
  };
  componentDidMount() {
    this.mount = true;
    this.baseData = this.state.data;
    if (localStorage.getItem('stGroup')) {
      const data = { ...this.state.data };
      data.group = localStorage.getItem('stGroup');
      data.stuffing_date = localStorage.getItem('stStuffing') ?localStorage.getItem('stStuffing'): "";
      if (this.mount) {
        this.setState({ data }, () =>{
          this.getData();
          localStorage.removeItem('stGroup');
          localStorage.removeItem('stStuffing');
        });
      }
    }
  }
  componentWillUnmount() {
    this.mount = false;
  }
  handleUpload = () => {
    // const { selectedFile, data } = this.state;
    // if (selectedFile !== null || data.gambar_packing !== "") {
    //   this.setState({ openModalUpdate: true });
    // } else {
    //   this.setState({ openModalNotif: true });
    // }
    this.setState({ openModalUpdate: true });
  };
  
  handleShowImage = (image) => {
    if (this.mount)
      this.setState({ image, isOpen: true, openModalUpload: false });
  };
  closeLightBox = () => {
    const { currentOpenModalUpload } = this.state;
    if (this.mount)
      this.setState({ isOpen: false, openModalUpload: currentOpenModalUpload });
  };

  // handleAddFoto = () => {
  //   let { selectedIndex } = this.state;
  //   if (selectedIndex >= 0) {
  //     let tempFoto = { file: null, surface_file: "" };
  //     let foto = [...this.state.data.surface[selectedIndex].foto, tempFoto];
  //     const data = { ...this.state.data };
  //     data.surface[selectedIndex].foto = foto;
  //     this.setState({ data });
  //   }
  // };
  // handleDeleteFoto = index => {
  //   const { selectedIndex } = this.state;
  //   if (selectedIndex >= 0) {
  //     const data = { ...this.state.data };
  //     const foto = data.surface[selectedIndex].foto.filter(
  //       (s, idx) => idx !== index
  //     );
  //     data.surface[selectedIndex].foto = foto;
  //     if (this.mount) this.setState({ data });
  //   }
  // };

  handleOpenModalUpload = (idx) => {
    this.setState({
      currentOpenModalUpload: true,
      openModalUpload: true,
      selectedDimensi: idx,
    });
  };

  handleDeleteQc = (index) => {
    const data = { ...this.state.data };
    const titik = data.titik.filter((s, idx) => idx !== index);
    const detail = data.detail.filter((s, idx) => idx !== index);
    data.titik = titik;
    data.detail = detail;
    if (this.mount)
      this.setState({ data, selectedIndex: -1, selectedDimensi: -1 });
  };
  handleDeleteTitik = (index, idx) => {
    console.log(index, idx);
    if (index >= 0 && idx >= 0) {
      let data = { ...this.state.data };
      let titik = [...data.titik[index]];
      const temp = titik.filter((s, id) => id !== idx);
      data.titik[index] = temp;
      if (this.mount) this.setState({ data });
    }
  };
  isPdf(val) {
    let temp = val.substring(val.length - 4);
    temp = temp.replace(".", "");
    let pdf = false;
    if (temp.toLowerCase() === "pdf") {
      pdf = true;
    }
    return pdf;
  }
  handleOpenPdf = (link) => {
    window.open(link);
  };
  showItem = (container) => {
    const { data } = this.state;
    for (var i = 0; i < data.titik[0].length; i++) {
      if (data.titik[0][i].container == container) {
        data.titik[0][i].is_show = true;
      }
    }
    this.setState({ data });
  };
  handleHideDetail = (index, idx) => {
    let data = { ...this.state.data };
    let titik = [ ...data.titik[index] ];
    let dimensi = { ...titik[idx] };
    dimensi.is_show = !dimensi.is_show;
    titik[idx]=dimensi;
    data.titik[index] = titik;
    if (this.mount) {
      this.setState({ data });
    }
  };
  render() {
    const {
      data,
      openModalUpdate,
      uploading,
      isOpen,
      image,
      openModalNotif,
      openModalUpload,
      selectedIndex,
      selectedDimensi,
      status,
      isProcessed,
      stuffing_type,
      eItems
    } = this.state;
    return (
      <div className="main-content">
        <Grid fluid>
          <Row>
            <Col md={9}>
              <div className="card">
                <div className="content">
                  <Row>
                    <Col md={4}>
                      <Input
                        onChange={this.handleChange}
                        value={data.group}
                        name="group"
                        label="Group"
                      />
                    </Col>
                    <Col md={4}>
                      <div className="form-group">
                        <label>Stuffing Date</label>
                        <Datetime
                          timeFormat={false}
                          dateFormat={"DD-MM-YYYY"}
                          inputProps={{ placeholder: "Tanggal Stuffing" }}
                          value={
                            data.stuffing_date ? new Date(data.stuffing_date) : ""
                          }
                          onChange={(e) => this.handleChangeDate(e, "stuffing_date")}
                        />
                      </div>
                    </Col>
                    {/* <Col md={8}>
                      <div className="form-group">
                        <label>Stuffing Date</label>
                        <InputGroup>
                          <Datetime
                            timeFormat={false}
                            dateFormat={"DD-MM-YYYY"}
                            inputProps={{ placeholder: "Dari" }}
                            value={
                              data.dateFrom ? new Date(data.dateFrom) : ""
                            }
                            onChange={(e) => this.handleChangeDate(e, "dateFrom")}
                          />
                          <InputGroup.Addon>
                            <i className="fa fa-minus" />
                          </InputGroup.Addon>
                          <Datetime
                            timeFormat={false}
                            dateFormat={"DD-MM-YYYY"}
                            inputProps={{ placeholder: "Sampai" }}
                            value={data.dateTo ? new Date(data.dateTo) : ""}
                            onChange={(e) => this.handleChangeDate(e, "dateTo")}
                          />
                        </InputGroup>
                      </div>
                    </Col> */}
                  </Row>
                  <Row>
                    <Col md={7}>
                      {eItems &&
                        eItems.map((item, idx) => (
                          <React.Fragment key={idx}>
                            {item.jumlah > 0 && (
                              <Row key={idx}>
                                <Col
                                  md={12}
                                  style={{ cursor: "pointer" }}
                                  onClick={() => this.showItem(item.container)}
                                >
                                  {item.container} :{" "}
                                  {item.jumlah} Pcs
                                </Col>
                              </Row>
                            )}
                          </React.Fragment>
                        ))}
                    </Col>
                    <Col md={5} style={{ textAlign: "right" }}>
                      <button
                        className="btn btn-fill btn-primary"
                        onClick={() => this.getData()}
                      >
                        Search
                      </button>
                    </Col>
                  </Row>
                </div>
              </div>
            </Col>
            <Col md={9}>
              {data.titik &&
                data.titik.map((titik, index) => (
                  <React.Fragment key={index}>
                    {titik && titik.map((t,idx)=>(
                      <div
                      className="card"
                      key={idx}
                      style={{
                        display: t.is_show ? "block" : "none",
                      }}
                    >
                      <div className="content">
                        <Row>
                          <Col md={8}>
                            {/* <label
                              style={{ fontSize: "25px" }}
                            >{`${data.code} - ${data.customer_code}`}</label> */}
                          </Col>
                          {/* <Col md={4} style={{ textAlign: "right" }}>
                            <button
                              className="btn btn-fill btn-danger"
                              onClick={() => this.handleDeleteQc(index)}
                            >
                              <i className="fa fa-trash"></i>
                            </button>
                          </Col> */}
                          <Col md={4} style={{ textAlign: "right" }}>
                            <button
                              className="btn btn-fill btn-secondary"
                              style={{ marginRight: "5px", fontWeight: "bold" }}
                              onClick={() => this.handleHideDetail(index,idx)}
                            >
                              _
                            </button>
                            {/* <button
                              className="btn btn-fill btn-danger"
                              onClick={() => this.handleDeleteTitik(index)}
                            >
                              <i className="fa fa-trash"></i>
                            </button> */}
                          </Col>
                        </Row>
                        <Row>
                          <React.Fragment>
                            <Col md={3}>
                              <Input
                                onChange={(e) =>
                                  this.handleChangeDetail(e, "container")
                                }
                                value={t.container}
                                name="container"
                                label="Container"
                                disabled={true}
                              />
                            </Col>
                            <Col md={3} style={{ textAlign: "left" }}>
                              <div className="form-group">
                                <label>Stuffing Date</label>
                                <Datetime
                                  timeFormat={false}
                                  dateFormat={"DD-MM-YYYY"}
                                  inputProps={{ placeholder: "Stuffing Date", disabled: true }}
                                  value={
                                    t.transaction_date
                                      ? new Date(t.transaction_date)
                                      : ""
                                  }
                                  onChange={e => this.handleChangeDate(e,"transaction_date")}
                                />
                              </div>
                            </Col> 
                            <Col md={3}>
                              <Select
                                label="Status"
                                onChange={(e) =>
                                  this.handleChangeDetail(e, "status")
                                }
                                disabled={true}
                                options={status}
                                optionValue="value"
                                optionLabel="label"
                                name="status"
                                value={t.status}
                              />
                            </Col>
                            <Col md={3}>
                              <Select
                                label="Stuffing Type"
                                onChange={(e) =>
                                  this.handleChangeDetail(e, "id_stuffing_type")
                                }
                                disabled={true}
                                options={stuffing_type}
                                optionValue="value"
                                optionLabel="label"
                                name="id_stuffing_type"
                                value={t.id_stuffing_type}
                              />
                            </Col>
                          </React.Fragment>
                        </Row>
                        <Row>
                          <React.Fragment>
                            <Col md={12}>
                              {t && t.dimensi.map((tdim, ctr) => (
                                <React.Fragment key={ctr}>
                                  {tdim.is_extra && (
                                    <Row>
                                      <Col md={4}>
                                        <Input
                                          disabled={true}
                                          value={tdim.stuffing_name}
                                          name="stuffing_name"
                                          label="Stuffing Name"
                                        />
                                      </Col>
                                      <Col md={4}>
                                        <Input
                                          disabled={true}
                                          value={tdim.stuffing_name_english}
                                          name="stuffing_name_english"
                                          label="Stuffing Name (English)"
                                        />
                                      </Col>
                                    </Row>
                                  )}
                                  <Row>
                                    <Col md={8}>
                                      <div className="form-group">
                                        {!tdim.is_extra && (
                                          <label>{`${tdim.description}`}</label>
                                        )}
                                        <InputGroup>
                                          <InputGroup.Addon
                                            style={{
                                              // cursor: "pointer",
                                              border: "1px solid #E3E3E3",
                                            }}
                                          >
                                            <Checkbox
                                              style={{ float: "left" }}
                                              disabled={true}
                                              isChecked={tdim.status==="1"?true:false}
                                              id={`nilai${index}${idx}`}
                                              name={`nilai${index}${idx}`}
                                            />
                                            {tdim.status_image && <div>
                                                <img
                                                  alt=""
                                                  style={{
                                                    display: "block",
                                                    margin: "0 auto",
                                                    width: "100%",
                                                    maxWidth: "100px",
                                                    cursor: "pointer",
                                                    float: "left",
                                                  }}
                                                  src={`${qcStuffingImg}${tdim.status_image}`}
                                                  onClick={() =>
                                                    this.handleShowImage(
                                                      `${qcStuffingImg}${tdim.status_image}`
                                                    )
                                                  }
                                                />
                                              </div>}
                                          </InputGroup.Addon>
                                        </InputGroup>
                                      </div>
                                    </Col>
                                    <Col md={4}>
                                      <Input
                                        onChange={(e) =>
                                          this.handleChangeTitik(
                                            e,
                                            index,
                                            idx,
                                            "desc"
                                          )
                                        }
                                        disabled={true}
                                        value={tdim.desc}
                                        name="desc"
                                        label="desc"
                                      />
                                    </Col>
                                  </Row>
                                </React.Fragment>
                              ))}
                            </Col>
                          </React.Fragment>
                        </Row>
                      </div>
                    </div>
                    ))}
                  </React.Fragment>
                ))}
            </Col>
            {/* <Row>
              <Col md={9} style={{ textAlign: "right" }}>
                <button
                  className="btn btn-fill btn-primary"
                  onClick={() => this.handleUpload()}
                >
                  Update
                </button>
              </Col>
            </Row> */}
          </Row>
        </Grid>
        <Modal
          bsSize="small"
          show={openModalUpdate}
          onHide={() => this.setState({ openModalUpdate: false })}
        >
          <Modal.Header closeButton>
            <Modal.Title>Update Stuffing</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <Grid fluid>
              <Row>
                <Col md={12}>Proceed Update ?</Col>
              </Row>
            </Grid>
          </Modal.Body>
          <Modal.Footer>
            <button
              onClick={() => this.setState({ openModalUpdate: false })}
              className="btn btn-fill btn-secondary"
            >
              Cancel
            </button>
            <button
              onClick={() => this.handleProceed()}
              className="btn btn-fill btn-success"
              disabled={isProcessed}
            >
              Proceed
            </button>
          </Modal.Footer>
        </Modal>
        <Modal
          bsSize="small"
          show={openModalUpload}
          onHide={() =>
            this.setState({
              openModalUpload: false,
              currentOpenModalUpload: false,
            })
          }
        >
          <Modal.Header closeButton>
            <Modal.Title>Upload Gambar</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <Grid fluid>
              <Row>
                <Col md={12}>
                  <input
                    style={{ display: "none" }}
                    type="file"
                    name="uploadFile"
                    id="uploadFile"
                    onChange={this.handleSelectedFile}
                  />
                  Upload Image [{" "}
                  <label
                    style={{
                      color: "blue",
                      textDecoration: "underline",
                      cursor: "pointer",
                    }}
                    htmlFor="uploadFile"
                  >
                    UPLOAD
                  </label>{" "}
                  ]
                  {selectedIndex >= 0 &&
                    selectedDimensi >= 0 && (
                      <React.Fragment>
                        {data.titik[selectedIndex][selectedDimensi].file ? (
                          <div>
                            <img
                              alt=""
                              style={{
                                display: "block",
                                margin: "0 auto",
                                width: "100%",
                                maxWidth: "100px",
                                cursor: "pointer",
                                float: "left",
                              }}
                              src={URL.createObjectURL(
                                data.titik[selectedIndex][selectedDimensi].file
                              )}
                              onClick={() =>
                                this.handleShowImage(
                                  URL.createObjectURL(
                                    data.titik[selectedIndex][selectedDimensi].file
                                  )
                                )
                              }
                            />
                          </div>
                        ) : (
                          <React.Fragment>
                            {data.titik[selectedIndex][selectedDimensi].status_image && (
                              <div>
                                <img
                                  alt=""
                                  style={{
                                    display: "block",
                                    margin: "0 auto",
                                    width: "100%",
                                    maxWidth: "100px",
                                    cursor: "pointer",
                                    float: "left",
                                  }}
                                  src={qcStuffingImg+data.titik[selectedIndex][selectedDimensi].status_image
                                  }
                                  onClick={() =>
                                    this.handleShowImage(
                                      qcStuffingImg+data.titik[selectedIndex][selectedDimensi].status_image
                                    )
                                  }
                                />
                            </div>
                            )}
                          </React.Fragment>
                        )}
                      </React.Fragment>
                  )}
                </Col>
              </Row>
            </Grid>
          </Modal.Body>
          <Modal.Footer>
            <button
              onClick={() =>
                this.setState({
                  openModalUpload: false,
                  currentOpenModalUpload: false,
                })
              }
              className="btn btn-fill btn-secondary"
            >
              Close
            </button>
          </Modal.Footer>
        </Modal>

        <Modal
          bsSize="small"
          show={openModalNotif}
          onHide={() => this.setState({ openModalNotif: false })}
        >
          <Modal.Header closeButton>
            <Modal.Title>Notification</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <Grid fluid>
              <Row>
                <Col md={12}>Gambar belum di upload !</Col>
              </Row>
            </Grid>
          </Modal.Body>
          <Modal.Footer>
            <button
              onClick={() => this.setState({ openModalNotif: false })}
              className="btn btn-fill btn-secondary"
            >
              Cancel
            </button>
          </Modal.Footer>
        </Modal>
        <LightBox
          isOpen={isOpen}
          images={image}
          closeLightBox={this.closeLightBox}
        />
        {uploading && (
          <div style={{ position: "absolute", top: "50vh", left: "50%" }}>
            <Loader type="Circles" color="#00BFFF" height="50" width="50" />
          </div>
        )}
      </div>
    );
  }
}

export default QCStuffing;



// WEBPACK FOOTER //
// ./src/views/qc/stuffing/detail.jsx